import { CheckBox, Icon } from "web/components"

import { useLocationPhotos } from "web/hooks/data"

import placeholderImage from "web/images/placeholder.svg"
import { isNonEmptyArray } from "web/services/helpers"

export default function Header({
  title,
  location,
  primarySubject,
  selectionEnabled,
  onSelectionChanged,
  onClick,
  onClose,
}) {
  const photos = useLocationPhotos(location.id)
  const hasPhotos = isNonEmptyArray(photos)

  const imageClasses = "h-full w-full rounded-t-md object-cover"

  function handleSelectionChanged() {
    onSelectionChanged({
      ...primarySubject,
      selected: !primarySubject.selected,
    })
  }

  function handleClose(e) {
    e.stopPropagation()
    onClose()
  }

  return (
    <div className="relative h-40" onClick={onClick}>
      <div className="relative mb-2 h-full w-full">
        <div className="absolute bottom-0 left-0 right-0 max-w-full truncate bg-gray-700/70 p-1 text-white">
          {title}
        </div>
        <img
          className={imageClasses}
          draggable="false"
          alt="asset"
          src={hasPhotos ? photos[0].thumbnail_url : placeholderImage}
        />
      </div>
      {selectionEnabled && (
        <div className="absolute left-2 top-2 rounded-full bg-white">
          <CheckBox
            value={{ value: primarySubject.selected || false }}
            onChange={handleSelectionChanged}
            showValueLabel={false}
          />
        </div>
      )}
      {onClose && (
        <div
          className="absolute right-2 top-2 grid h-5 w-5 cursor-pointer place-content-center rounded bg-white"
          onClick={handleClose}
        >
          <Icon name="x-mark" width="14px" height="14px" />
        </div>
      )}
    </div>
  )
}
